import { ReactNode } from 'react';

import { loaders } from 'entities';

import { LoginValidation } from './Validation';

import { useUrlStateV2 } from 'hooks';
import { useAuth } from 'providers/Auth';

export function LinkLoginWrapper({ children }: { children: ReactNode }) {
  const { setLogin } = useAuth();

  const [{ token }, setQuery] = useUrlStateV2({
    token: '',
  });

  const { loading } = loaders.auth.linkVerify.use({
    blockLoad: !token,

    params: {
      token,
    },

    onLoad: setLogin,

    onError: () => setQuery({ token: null }),
  });

  if (token && loading) return <LoginValidation />;

  return <>{children}</>;
}
